import { type FunctionComponent, useEffect, useState } from 'react';

import './style.scss';

type PropsT = {
  images: string[];
  intervalMs?: number;
};

const ImageSlider: FunctionComponent<PropsT> = ({
  images,
  intervalMs = 10000,
}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, intervalMs);
    return () => {
      clearInterval(timer);
    };
  }, [images.length, intervalMs]);

  return (
    <div styleName="container">
      {images.map((src, i) => (
        <img
          alt=""
          key={src}
          src={src}
          styleName={i === index ? 'slide active' : 'slide'}
        />
      ))}
    </div>
  );
};

export default ImageSlider;
